import {
    PPD_SET_ACTIVE_TAB,
    PPD_CLEAR_STATE
} from '../constants';
import { ClearStateAction, SetActiveTabIndexAction } from "~/frontend/src/actions/panelPropsDialog";

const relevantActions = [
    PPD_SET_ACTIVE_TAB,
    PPD_CLEAR_STATE
];

export type PanelPropsDialogProps = {
    activeTabIndex? : number
};

export type PanelPropsDialogState = {
    [ panelKey: string ]: PanelPropsDialogProps;
}

/**
 *
 * @param state
 * @param action
 */
export default function panelPropsDialogReducer( state: PanelPropsDialogState = {},
                                                 action: SetActiveTabIndexAction | ClearStateAction ): PanelPropsDialogState {
    let changed = false,
        panelState;

    if ( relevantActions.includes( action.type ) ) {
        const { panelKey } = action;

        if ( state[ panelKey ] ) {
            // copy current (stay immutable!)
            panelState = Object.assign( {}, state[ panelKey ] );
        }
        else {
            panelState = {};
        }

        switch ( action.type ) {
            case PPD_SET_ACTIVE_TAB:
                if ( action.activeTabIndex !== undefined ) {
                    changed = true;

                    panelState.activeTabIndex = action.activeTabIndex;
                }
                break;

            case PPD_CLEAR_STATE:
                changed = true;
                panelState = undefined;

                break;
        }

        if ( changed ) {
            // copy current (stay immutable - but only for the outer state)
            state = Object.assign( {}, state );

            if ( panelState !== undefined ) {
                state[ panelKey ] = panelState;
            }
            else {
                delete state[ panelKey ];
            }
        }
    }

    return state;
}
